import Vue from 'vue'
import moment from 'moment'

Vue.filter('date', function (value, format) {
  if (value) {
    return moment(value).format(format)
  }
  return value
})

Vue.filter('date8', function (value) {
  if (value) {
    return moment(value).format('YYYYMMDD')
  }
  return value
})

Vue.filter('dateFmt8', function (value) {
  if (value) {
    return moment(value).format('YYYY-MM-DD')
  }
  return value
})

Vue.filter('date14', function (value) {
  if (value) {
    return moment(value).format('YYYYMMDDHHmmss')
  }
  return value
})

Vue.filter('dateFmt14', function (value) {
  if (value) {
    return moment(value).format('YYYY-MM-DD HH:mm:ss')
  }
  return value
})

Vue.filter('dateFmt12', function (value) {
  if (value) {
    return moment(value).format('YYYY-MM-DD HH:mm')
  }
  return value
})

Vue.filter('YYYYMD', function (value) {
  if (value) {
    return moment(value).format('YYYY-M-D')
  }
  return value
})

Vue.filter('dateFmtDot8', function (value) {
  if (value) {
    return moment(value).format('YYYY.MM.DD')
  }
  return value
})

Vue.filter('timeFmt4', function (value) {
  if (value) {
    return moment(value).format('HH:mm')
  }
  return value
})
